"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tooltipPlacement = void 0;
const classnames_1 = __importDefault(require("classnames"));
const commonStyles_1 = require("root/src/client/web/commonStyles");
const orEmpty_1 = __importDefault(require("root/src/shared/util/orEmpty"));
const Typography_1 = __importStar(require("root/src/client/web/typography/Typography"));
const withStylesHof_1 = require("root/src/client/util/withStylesHof");
const react_1 = __importDefault(require("react"));
const style = {
    root: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover > div': {
            visibility: 'visible',
            opacity: 1,
        },
    },
    tooltip: {
        visibility: 'hidden',
        backgroundColor: commonStyles_1.colorsNew.dark2,
        position: 'absolute',
        transform: 'translateY(50%)',
        minWidth: 200,
        borderRadius: 6,
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        boxShadow: '5px 5px 10px black',
        zIndex: 999,
        margin: 10,
        padding: [[10, 5]],
    },
    visible: {
        visibility: 'visible',
        opacity: 1,
    },
};
exports.tooltipPlacement = {
    left: 'left',
    right: 'right',
};
const TooltipWrapper = ({ children, tooltipText, tooltipHeader, classes, visible, displayInTable, placement, }) => (<div className={classes.root} style={{ justifyContent: displayInTable ? 'flex-start' : 'center' }}>
		{tooltipText && (<div style={Object.assign(Object.assign({}, (0, orEmpty_1.default)(placement, { [exports.tooltipPlacement[placement]]: 0 })), (0, orEmpty_1.default)(displayInTable, { left: 0 }))} className={(0, classnames_1.default)(classes.tooltip, 'tooltipText', visible && classes.visible)}>
				{tooltipHeader && (<Typography_1.default variant={Typography_1.typographyVariants.miniBold} color={commonStyles_1.colorsNew.light4}>
						{tooltipHeader}
					</Typography_1.default>)}
				<Typography_1.default variant={Typography_1.typographyVariants.paragraphBold}>
					{tooltipText}
				</Typography_1.default>
			</div>)}
		{children}
	</div>);
exports.default = (0, withStylesHof_1.withStylesHof)(style, { name: 'MuiTooltipWrapper' }, TooltipWrapper);
